import { render, staticRenderFns } from "./InventarioSucursal.vue?vue&type=template&id=775e1c1a"
import script from "./InventarioSucursal.vue?vue&type=script&lang=js"
export * from "./InventarioSucursal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports